/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Controller } from "@hotwired/stimulus";

export default class TOSDialog extends Controller<HTMLDialogElement> {
	acceptTOS() {
		localStorage.setItem("accepted-tos", "true");
		console.log("Dispatching!");
		this.dispatch("accept");
		this.element.close();
	}

	rejectTOS() {
		this.element.close();
	}
}
